import React from "react";

function About() {
  return (
    <div className="p-10">
      <h2 className="text-3xl font-bold text-blue-900 mb-4">About Us</h2>
      <p>
        At <b>Seafood</b>, we specialize in delivering the freshest crabs, lobsters, prawns, and fish. 
        Our passion is to bring the ocean’s flavors to your table.
      </p>
    </div>
  );
}

export default About;
